import { klona } from 'klona'

import { PRINT_SETTINGS_SET, PRINT_SETTINGS_STATUS_SET } from './mutation.types'
import { PRINT_SETTINGS_UPDATE, PRINT_SETTINGS_FETCH } from './action.types'

import * as PrintSettingsService from '@/services/print-settings/vuex.service'
import type { GetterTree, ActionTree, MutationTree } from 'vuex'
import type { RequestStatus } from '@/types/api'
import type { PrintSettings } from '@/types/printing.model'

type State = {
  printSettings: PrintSettings | undefined
  printSettingsStatuses: { save?: RequestStatus, getAll?: RequestStatus }
}
const initialState: State = {
  printSettings: undefined,
  printSettingsStatuses: { save: undefined, getAll: undefined },
}

// TODO: add correct RootState for generic (or migrate to Pinia) (kirill/SC-64188)
const getters: GetterTree<State, State> = {
  printSettings: state => state.printSettings,
  printSettingsStatuses: state => state.printSettingsStatuses,
}

const actions: ActionTree<State, State> = {
  async [PRINT_SETTINGS_UPDATE]({ commit, getters }, printSettings: Partial<PrintSettings>) {
    try {
      commit(PRINT_SETTINGS_STATUS_SET, { save: 'pending' })
      commit(PRINT_SETTINGS_SET, await PrintSettingsService.save(printSettings, getters.user))
      commit(PRINT_SETTINGS_STATUS_SET, { save: 'ok' })
    } catch (e) {
      commit(PRINT_SETTINGS_STATUS_SET, { save: 'error' })
      throw e
    }
  },

  async [PRINT_SETTINGS_FETCH]({ state, commit, getters }, force = false) {
    if (state.printSettings && !force) {
      return
    }
    try {
      commit(PRINT_SETTINGS_STATUS_SET, { getAll: 'pending' })
      commit(PRINT_SETTINGS_SET, await PrintSettingsService.getAll(getters.user))
      commit(PRINT_SETTINGS_STATUS_SET, { getAll: 'ok' })
    } catch (e) {
      commit(PRINT_SETTINGS_STATUS_SET, { getAll: 'error' })
      throw e
    }
  },
}

const mutations: MutationTree<State> = {
  [PRINT_SETTINGS_SET](state, printSettings) {
    state.printSettings = klona(printSettings)
  },

  [PRINT_SETTINGS_STATUS_SET](state, status) {
    state.printSettingsStatuses = { ...state.printSettingsStatuses, ...status }
  },
}

export default {
  state: initialState,
  getters,
  actions,
  mutations,
  name: 'printSettings',
}
